export default "__VITE_ASSET__47533756__"